export type FetchClientError = Error & { status: number; data: unknown };

export const isFetchClientError = (error: unknown): error is FetchClientError =>
  error instanceof Error &&
  typeof (error as { status?: unknown }).status === "number";
